export default __webpack_public_path__ + "static/media/CSRealCase3-en-moblie.530db032.jpg";